import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import { FaCalendar, FaExternalLinkAlt, FaInfoCircle, FaLink, FaPhone, FaTimes, FaUser } from "react-icons/fa"
import { Button } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"

import Tooltip from "../components/ui/ToolTip"

import 'tippy.js/dist/tippy.css';

import { Link } from "react-router-dom";
import CopyToClipBoard from "../utils/CopyToClipBoard"
import { FormatDateToDDMMYYHHMM } from "../utils/FormatDate"
import { getCurrentMonth } from "../utils/GetDates"



const FunnelLeads = () => {

  const [loadingStatus, setLoadingStatus] = useState(false)

  const [brandOrigin, setBrandOrigin] = useState("") // Input de búsqueda
  const [searchCriteria, setSearchCriteria] = useState("leadName")
  const [leadName, setLeadName] = useState("")

  const { start, end } = getCurrentMonth()
  
  // Ajustar las fechas para que incluyan todo el día
  const [startDate, setStartDate] = useState(() => {
    const date = new Date(start);
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString();
  });
  
  const [endDate, setEndDate] = useState(() => {
    const date = new Date(end);
    date.setUTCHours(23, 59, 59, 999);
    return date.toISOString();
  });

  const [users, setUsers] = useState([])
  const [workers, setWorkers] = useState([])

  const [leadOrigin, setLeadOrigin] = useState("") // Filtro de búsqueda de origen de lead
  const [entryOrigin, setEntryOrigin] = useState("") // Filtro de búsqueda de origen de entrada del lead
  const [responsible, setResponsible] = useState("") // Filtro de búsqueda del responsable del lead
  const [leadStage, setLeadStage] = useState("") // Filtro de búsqueda por la etapa del lead

  const handleResetSearch = () => {
    setLeadName("")
  }

  const getUsers = async () => {
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/registroLeads?limit=0`
      let andFilters = [];

      if (startDate) {
        const adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }
      if (leadName) {
        if (searchCriteria === "leadName") {
          url += `&where[leadName][contains]=${leadName}`
        } else if (searchCriteria === "phone") {
          url += `&where[phone][contains]=${leadName}`
        } else if (searchCriteria === "dni") {
          url += `&where[dni][like]=${leadName}`
        } else if (searchCriteria === "id") {
          url += `&where[id][equals]=${leadName}`
        }
      }
      if (leadOrigin) {
        url += `&where[leadOrigin][equals]=${leadOrigin}`
      }
      if (entryOrigin) {
        url += `&where[entryOrigin][equals]=${entryOrigin}`
      }
      if (responsible) {
        url += `&where[responsible][equals]=${responsible}`
      }
      if (brandOrigin) {
        url += `&where[brandOrigin][equals]=${brandOrigin}`
      }
      // if (leadStage) {
      //   url += `&where[stage][equals]=${leadStage}`
      // }
      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }

      const response = await axios.get(url)

      setUsers(response.data.docs)
    } catch (e) {
      toast.error(e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getWorkers = async () => {
    try {
      //const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true&where[area][equals]=Comercial`)
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`)
      const sellers = response.data.docs.filter((w) => w.area === "Comercial" || w.area === "Administracion" || w.puesto === "JEFE DE MARKETING")
      setWorkers(sellers)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getUsers()
    getWorkers()
  }, [])

  useEffect(() => {
    getUsers()
  }, [startDate, endDate, leadOrigin, entryOrigin, responsible, brandOrigin])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (leadName === "") {
      getUsers()
    } 
  }, [leadName]);

  const stages = [
    { name: "Leads entrantes", value: "79717403" },
    { name: "Web/Correo entrantes", value: "79869559" },
    { name: "Aún no dice que no, seguimiento por 2 días", value: "81615327" },
    { name: "Leads interesados", value: "79717407" },
    { name: "Leads no interesados", value: "79719259" },
    { name: "Muy misio", value: "79753787" },
    { name: "Llamadas programadas", value: "79719263" },
    { name: "Meets programados", value: "79717419" },
    { name: "Cotización enviada (prospecto)", value: "79717411" },
    { name: "Me rendí", value: "81439775" },
    { name: "Prospecto a futuro", value: "81617899" },
    { name: "Perdieron interés (prospecto)", value: "79719267" },
    { name: "Trabaja en otra agencia / Freelance", value: "81615803" },
  ]

  const stageGroups = stages.map((s) => ({
    stage: s.name,
    leads: users.filter((l) => l.stage === s.value),
  }));


  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaUser className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Funnel de leads</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="truncate">Buscar por:</span>
              <select
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
                <option value="id">ID</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar lead"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={leadName}
                onChange={(e) => setLeadName(e.target.value)}
              />
              {leadName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => getUsers()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>
      
      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-1 mb-1 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-between overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-4 items-center justify-center">
            
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Origen de lead:</span>
              <select
                value={leadOrigin}
                onChange={(e) => setLeadOrigin(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Todos</option>
                <option value={"Facebook Ads"}>Facebook Ads</option>
                <option value={"Google Ads"}>Google Ads</option>
                <option value={"Linkedin Ads"}>Linkedin Ads</option>
                <option value={"Tiktok Ads"}>Tiktok Ads</option>
                <option value={"Youtube Ads"}>Youtube Ads</option>
                <option value={"Web orgánico"}>Web orgánico</option>
                <option value={"Facebook"}>Facebook</option>
                <option value={"Google"}>Google</option>
                <option value={"Linkedin"}>Linkedin</option>
                <option value={"Tiktok"}>Tiktok</option>
                <option value={"Youtube"}>Youtube</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Origen de entrada:</span>
              <select
                value={entryOrigin}
                onChange={(e) => setEntryOrigin(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Todos</option>
                <option value={"Kommo"}>Kommo</option>
                <option value={"WhatsApp"}>WhatsApp</option>
                <option value={"Llamada"}>Llamada</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Responsable:</span>
              <select
                value={responsible}
                onChange={(e) => setResponsible(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value="">Todos</option>
                {workers.map((worker) => (
                  <option value={worker.id}>{worker.name}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Origen marca:</span>
              <select
                value={brandOrigin}
                onChange={(e) => setBrandOrigin(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Todos</option>
                <option value={"Sin definir"}>Sin definir</option>
                <option value={"Mundo Digital"}>Mundo Digital</option>
                <option value={"Allsavfe"}>Allsavfe</option>
                <option value={"W3P"}>W3P</option>
                <option value={"Monstruo Creativo"}>Monstruo Creativo</option>
                <option value={"SEOluciones"}>SEOluciones</option>
                <option value={"Nodo"}>Nodo</option>
                <option value={"Aura BTL"}>Aura BTL</option>
                <option value={"Conviertelo"}>Conviertelo</option>
                <option value={"Lucuma"}>Lucuma</option>
              </select>
            </div>
          </div>

          <div className="flex-shrink-0">
            <span className="text-xs text-gray-700 font-bold pl-4">
              {users.length} leads encontrados
            </span>
          </div>
          
        </div>
      </div>

      {/* Barra de fechas */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between w-full gap-10">
        <div className="flex flex-row gap-4 items-center justify-center w-full px-4">

          <div className="flex flec-row items-center justify-center gap-2">
            <label className="block text-xs font-medium text-gray-900">
              Fecha ingreso inicio
            </label>

            <div className="flex flex-row items-center justify-center gap-4">
              <input 
                type="date" 
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                value={new Date(startDate).toISOString().split('T')[0]}
                onChange={(e) => setStartDate(new Date(e.target.value).toISOString())}
              />
            </div> 
          </div>

          <div className="flex flec-row items-center justify-center gap-2">
            <label className="block text-xs font-medium text-gray-900">
              Fecha ingreso fin
            </label>

            <div className="flex flex-row items-center justify-center gap-4">
              <input 
                type="date" 
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                value={new Date(endDate).toISOString().split('T')[0]}
                onChange={(e) => setEndDate(new Date(e.target.value).toISOString())}
              />
            </div> 
          </div>
        </div>
      </div>

      {/* Body */}
      <div className={`flex-grow overflow-y-auto flex min-h-0`}>
        {loadingStatus ? (
            <LoadingScreen />
          ) : users.length === 0 ? (
            <NoDataScreen />
          ) : (
            stageGroups.map((s) => (
              <div className="flex flex flex-grow flex-inine w-[200%] p-1">
                <div className="border w-[350px] flex flex-grow border-gray-300 bg-gray-100 rounded p-2 shadow">
                  <div className="flex flex-col gap-4 w-ful flex-grow">
                    <div className="flex flex-row justify-between text-xs font-semibold items-center">
                      <span>{s.stage}</span>
                      <span>{s.leads.length} leads</span>
                    </div>
                    <div className="flex flex-grow flex-col gap-2 overflow-y-auto w-full [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                      {s.leads.length === 0 ? (
                        <div className="flex flex-grow justify-center items-center h-full bg-white rounded text-xs">
                          <span className="flex flex-inline text-semibold text-gray-400 gap-2">Sin leads <FaInfoCircle /></span>
                        </div>
                      ) : (
                        s.leads.map((l) => (
                          <div className="shadow-md text-xs rounded hover:bg-gray-50 bg-white transition-all duration-100 flex flex-col gap-1 p-2">
                            <div className="flex flex-inline justify-between items-center">
                              <span>{l.leadName}</span>
                              <Tooltip content={"Ver lead"}>
                                <Link 
                                  to={`/home/trackeoLeads/${l.id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <FaExternalLinkAlt className="text-xs text-blue-500"/>
                                </Link>
                              </Tooltip>
                            </div>
                            <div className="flex flex-inline justify-between items-center">
                              <span>{l.phone}</span>
                              <Tooltip content={"Copiar teléfono"}>
                                <button onClick={() => CopyToClipBoard(l.phone)}>
                                  <FaPhone className="text-xs"/>
                                </button>
                              </Tooltip>
                            </div>
                            <div className="flex flex-inline justify-between items-center">
                              <span>{l.responsible?.name ? l.responsible?.name : "Sin responsable"}</span>
                              <Tooltip content={"Responsable"}>
                                <div>
                                  <FaUser className="text-xs"/>
                                </div>
                              </Tooltip>
                            </div>
                            <div className="flex flex-inline justify-between items-center">
                              <span>{FormatDateToDDMMYYHHMM(l.createdAt)}</span>
                              <Tooltip content={"Fecha de ingreso"}>
                                <div>
                                  <FaCalendar className="text-xs"/>
                                </div>
                              </Tooltip>
                            </div>
                            <div className="flex flex-inline justify-between items-center">
                              <span>{l.id}</span>
                              <Tooltip content={"Copiar ID"}>
                                <button onClick={() => CopyToClipBoard(l.id)}>
                                  <FaLink className="text-xs"/>
                                </button>
                              </Tooltip>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
        )}
      </div>

    </div>
  )
}

export default FunnelLeads
